import Main from './view/Main.vue';
import './assets/component.js';
let Vue = window.Vue;
Vue.config.productionTip = false;
window.$projectName = 'Kamis/main';

new Vue({
  render: h => h(Main)
}).$mount('#app');
